module.exports = __webpack_public_path__ + "static/img/img_form_1_ko.23846cdc.png";